import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type RemovePaymentMethodMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
}>;


export type RemovePaymentMethodMutation = { __typename?: 'mutation_root', update_arpaymentmethods?: { __typename?: 'arpaymentmethods_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'arpaymentmethods', id: number, customer_id: number }> } | null };


export const RemovePaymentMethodDocument = gql`
    mutation removePaymentMethod($id: bigint!) {
  update_arpaymentmethods(where: {id: {_eq: $id}}, _set: {active: false}) {
    affected_rows
    returning {
      id
      customer_id
    }
  }
}
    `;
export type RemovePaymentMethodMutationFn = Apollo.MutationFunction<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;

/**
 * __useRemovePaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemovePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentMethodMutation, { data, loading, error }] = useRemovePaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>(RemovePaymentMethodDocument, options);
      }
export type RemovePaymentMethodMutationHookResult = ReturnType<typeof useRemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationResult = Apollo.MutationResult<RemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationOptions = Apollo.BaseMutationOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/billing/queries/removePaymentMethod.mutation.gql}
 */
export async function removePaymentMethod(
  variables: RemovePaymentMethodMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<RemovePaymentMethodMutation['update_arpaymentmethods']>
export async function removePaymentMethod(
  variables: RemovePaymentMethodMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<RemovePaymentMethodMutation>
export async function removePaymentMethod(
  variables: RemovePaymentMethodMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<RemovePaymentMethodMutation['update_arpaymentmethods'] | RemovePaymentMethodMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<RemovePaymentMethodMutation>(
    RemovePaymentMethodDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_arpaymentmethods
}